/*
 * SeatFit reviews photo lightbox: one dialog per reviews section, showing every photo of the
 * clicked review with prev/next, Esc to close, and focus returned to the thumbnail.
 * The dialog is moved to <body>: Shrine animates sections with transforms, and position:fixed
 * inside a transformed ancestor would be trapped in the section box.
 */
(function () {
  'use strict';
  var NS = window.SeatFitReviews = window.SeatFitReviews || {};
  if (NS.Lightbox) return;

  function Lightbox() {
    var box = document.createElement('div');
    box.className = 'sf-rv-lb';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Customer photos');
    box.innerHTML =
      '<span class="sf-rv-lb__backdrop" data-lb-close></span>' +
      '<figure class="sf-rv-lb__frame">' +
      '<img class="sf-rv-lb__img" alt="">' +
      '<figcaption class="sf-rv-lb__cap"><span data-lb-name></span><span data-lb-count></span></figcaption>' +
      '</figure>' +
      '<button type="button" class="sf-rv-lb__btn sf-rv-lb__close" data-lb-close aria-label="Close">&times;</button>' +
      '<button type="button" class="sf-rv-lb__btn sf-rv-lb__nav sf-rv-lb__prev" data-lb-prev aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="sf-rv-lb__btn sf-rv-lb__nav sf-rv-lb__next" data-lb-next aria-label="Next photo">&#8250;</button>';
    document.body.appendChild(box);
    this.box = box;
    this.img = box.querySelector('.sf-rv-lb__img');
    this.name = box.querySelector('[data-lb-name]');
    this.count = box.querySelector('[data-lb-count]');
    this.urls = [];
    this.i = 0;
    this.back = null;
    var self = this;
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-lb-close]')) self.close();
      else if (t.closest('[data-lb-prev]')) self.go(-1);
      else if (t.closest('[data-lb-next]')) self.go(1);
    });
    this.onKey = function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowLeft') self.go(-1);
      else if (e.key === 'ArrowRight') self.go(1);
      else if (e.key === 'Tab') self.trapTab(e);
    };
    document.addEventListener('keydown', this.onKey);
  }

  Lightbox.prototype.show = function () {
    var n = this.urls.length;
    var url = this.urls[this.i];
    var sized = NS.render && NS.render.sized ? NS.render.sized : function (u) { return u; };
    this.img.src = sized(url, 1400);
    this.img.alt = 'Customer photo ' + (this.i + 1) + ' of ' + n + (this.caption ? ' from ' + this.caption : '');
    this.name.textContent = this.caption || '';
    this.count.textContent = n > 1 ? (this.i + 1) + ' / ' + n : '';
    this.box.classList.toggle('sf-rv-lb--single', n < 2);
  };

  Lightbox.prototype.open = function (urls, index, caption, back) {
    if (!urls || !urls.length) return;
    this.urls = urls;
    this.i = Math.max(0, Math.min(urls.length - 1, index || 0));
    this.caption = caption || '';
    this.back = back || null;
    this.show();
    this.box.hidden = false;
    document.documentElement.classList.add('sf-rv-lb-open');
    var close = this.box.querySelector('.sf-rv-lb__close');
    if (close) close.focus();
  };

  // aria-modal: Tab cycles through the dialog's own visible buttons, never the page behind it.
  Lightbox.prototype.trapTab = function (e) {
    var btns = Array.prototype.filter.call(this.box.querySelectorAll('.sf-rv-lb__btn'),
      function (b) { return b.offsetParent !== null; });
    if (!btns.length) return;
    e.preventDefault();
    var i = btns.indexOf(document.activeElement);
    var next = e.shiftKey ? (i <= 0 ? btns.length - 1 : i - 1) : (i + 1) % btns.length;
    btns[next].focus();
  };

  Lightbox.prototype.go = function (dir) {
    var n = this.urls.length;
    if (n < 2) return;
    this.i = (this.i + dir + n) % n;
    this.show();
  };

  Lightbox.prototype.close = function () {
    if (this.box.hidden) return;
    this.box.hidden = true;
    this.img.removeAttribute('src');
    document.documentElement.classList.remove('sf-rv-lb-open');
    if (this.back && this.back.focus) this.back.focus();
  };

  // The theme editor re-renders sections; the old dialog must not stay behind in <body>.
  Lightbox.prototype.destroy = function () {
    this.close();
    document.removeEventListener('keydown', this.onKey);
    if (this.box.parentNode) this.box.parentNode.removeChild(this.box);
  };

  NS.Lightbox = Lightbox;
})();
